import PropTypes from 'prop-types';
import React from 'react';
import PlanMessageBanner
  from 'Components/UI/ActivityFeed/Shared/HouseholdFeed/ThreadList/Thread/Body/Plan/FirstMessage/PlanMessageBanner';
import { Box } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { noop } from 'Helpers/PropTypes';
import useComponentDidMount from 'Hooks/useComponentDidMount';

const useStyles = buildUseStyles('MeetingHeader', (theme) => ({
  root: {
    marginTop: theme.spacing(1),
    paddingRight: theme.spacing(2),
    fontSize: theme.typography.h5.fontSize,
  },
  paper: {
    margin: theme.spacing(0, 2, 2, 0),
  },
}));

const PlanMessageContent = ({
  messageResource,
  onLoadComplete,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  useComponentDidMount(() => {
    onLoadComplete();
  });

  return (
    <Box className={classes.root}>
      <PlanMessageBanner
        messageResource={messageResource}
        classes={{
          paper: classes.paper,
        }}
      />
    </Box>
  );
};

PlanMessageContent.defaultProps = {
  onLoadComplete: noop,
};

PlanMessageContent.propTypes = {
  messageResource: PropTypes.object.isRequired,
  onLoadComplete: PropTypes.func,
};

export default PlanMessageContent;
